// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  padding: 16px;
  margin-top: 16px;
  margin-bottom: 16px;
  border: none;
}

.item-selection-section {
  margin-top: 20px;
}
.item-selection-section .item-list {
  min-height: 300px;
  margin: 10px 0px;
}

.btn-next:focus {
  outline: none;
}

.text-style {
  color: var(--color-card-text);
}

@media (max-width: 767px) {
  .marginTest {
    margin-top: 20px;
    padding-left: 0px;
    padding-right: 0px;
    margin-bottom: -15px;
  }
  .noPadding {
    padding: 0px;
  }
  .minHeight {
    min-height: 120px;
    box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.2);
  }
  .maxHeight {
    max-height: 45vh;
  }
}
@media (min-width: 768px) {
  .marginTest {
    margin-top: -145px;
  }
  .minHeight {
    min-height: 136px;
  }
  .maxHeight {
    max-height: 70vh;
  }
}
.text-right {
  text-align: end;
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/mobile/return-item/return-item.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AACF;;AACA;EACE,gBAAA;AAEF;AAAE;EAEE,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE;IACE,gBAAA;IACA,iBAAA;IACA,kBAAA;IACA,oBAAA;EACF;EAEA;IACE,YAAA;EAAF;EAGA;IACE,iBAAA;IACA,8CAAA;EADF;EAIA;IACE,gBAAA;EAFF;AACF;AAKA;EACE;IACE,kBAAA;EAHF;EAMA;IACE,iBAAA;EAJF;EAOA;IACE,gBAAA;EALF;AACF;AAQA;EACE,eAAA;AANF","sourcesContent":[".card {\n  padding: 16px;\n  margin-top: 16px;\n  margin-bottom: 16px;\n  border: none;\n}\n.item-selection-section {\n  margin-top: 20px;\n  // margin-bottom: 20px;\n  .item-list {\n    // border: 1px solid var(--color-primary);\n    min-height: 300px;\n    margin: 10px 0px;\n  }\n}\n.btn-next:focus {\n  outline: none;\n}\n\n.text-style{\n  color: var(--color-card-text);\n}\n\n@media (max-width: 767px) {\n  .marginTest {\n    margin-top: 20px;\n    padding-left: 0px;\n    padding-right: 0px;\n    margin-bottom: -15px;\n  }\n\n  .noPadding {\n    padding: 0px;\n  }\n\n  .minHeight {\n    min-height: 120px;\n    box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.2);\n  }\n\n  .maxHeight {\n    max-height: 45vh;\n  }\n}\n\n@media (min-width: 768px) {\n  .marginTest {\n    margin-top: -145px;\n  }\n\n  .minHeight {\n    min-height: 136px;\n  }\n\n  .maxHeight {\n    max-height: 70vh;\n  }\n}\n\n.text-right {\n  text-align: end;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
